import { defineStyleConfig } from '@chakra-ui/react'

export default defineStyleConfig({
  variants: {
    flushed: {
      _placeholder: {
        color: 'gray.300',
      },
      _focus: {
        borderBottomColor: 'primary.400',
        boxShadow: 'none',
      },
    },
  },
  defaultProps: {
    variant: 'flushed',
  },
})
